import {FC} from 'react'
import {Controller, Control} from 'react-hook-form'
import styles from './SearchForm.scss'
import {ErrorMessage} from 'jbc-front/components/presenters/form/ErrorMessage'
import moment from 'moment'
import {DateField} from './DateField'
import {Schema} from '../../schema'
import {UseFormSetValue, UseFormGetValues} from 'react-hook-form'

type DateRowProps = {
  header: string
  errorMessage: string | undefined
  names: ['alertStartStartOn', 'alertStartEndOn'] | ['baseDateStartOn', 'baseDateEndOn']
  control: Control<Schema>
  setValue: UseFormSetValue<Schema>
  getValues: UseFormGetValues<Schema>
}

const checkBeforeAndSetNewEndDate = (
  newValue: moment.Moment,
  setValue: UseFormSetValue<Schema>,
  getValues: UseFormGetValues<Schema>
) => {
  const newEndDate = newValue.clone().add(3, 'months').subtract(1, 'days')
  const checkDiffAndSet = (currentEndDate: string, newValue: moment.Moment, newEndDate: moment.Moment) => {
    if (moment(currentEndDate, 'YYYY/MM/DD').subtract(2, 'months') > newValue) {
      if (newEndDate.isBefore(moment(currentEndDate, 'YYYY/MM/DD'))) {
        setValue('alertStartEndOn', newEndDate.format('YYYY/MM/DD'))
      }
    }
  }
  checkDiffAndSet(getValues('alertStartEndOn'), newValue, newEndDate)
}

export const DateRow: FC<DateRowProps> = ({header, errorMessage, names, control, setValue, getValues}) => {
  // oxlint-disable-next-line typescript/no-explicit-any
  const onChangeDateField = (field: any, value: moment.Moment | string) => {
    if (typeof value === 'string') {
      field.onChange(value)
    } else {
      field.onChange(value.format('YYYY/MM/DD'))
    }
  }

  return (
    <div className={styles.detailsRow}>
      <div className={styles.detailsHeader}>{header}</div>
      <div className={styles.detailsBody}>
        <div className={styles.detailsBodyItems}>
          <div className={styles.alertDateSelect}>
            <Controller
              name={names[0]}
              control={control}
              render={({field}) => (
                <DateField
                  value={field.value}
                  inputProps={{isError: !!errorMessage}}
                  onChange={(value: moment.Moment | string) => {
                    if (field.name === 'alertStartStartOn' && moment.isMoment(value)) {
                      checkBeforeAndSetNewEndDate(value, setValue, getValues)
                    }
                    onChangeDateField(field, value)
                  }}
                  small
                />
              )}
            />
          </div>
          <span className={styles.detailsComplementText}>から</span>
          <div className={styles.alertDateSelect}>
            <Controller
              name={names[1]}
              control={control}
              render={({field}) => (
                <DateField
                  value={field.value}
                  inputProps={{isError: !!errorMessage}}
                  onChange={(value: moment.Moment | string) => onChangeDateField(field, value)}
                  small
                />
              )}
            />
          </div>
          <span className={styles.detailsComplementText}>の間</span>
        </div>
        <div className={styles.detailsBodyErrors}>{errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}</div>
      </div>
    </div>
  )
}
